export const COUNTRY_CODES = [
  { code: "+93", label: "Afghanistan", flag: "🇦🇫", iso: "AF" },
  { code: "+355", label: "Albania", flag: "🇦🇱", iso: "AL" },
  { code: "+213", label: "Algeria", flag: "🇩🇿", iso: "DZ" },
  { code: "+1-684", label: "American Samoa", flag: "🇦🇸", iso: "AS" },
  { code: "+376", label: "Andorra", flag: "🇦🇩", iso: "AD" },
  { code: "+244", label: "Angola", flag: "🇦🇴", iso: "AO" },
  { code: "+1-264", label: "Anguilla", flag: "🇦🇮", iso: "AI" },
  { code: "+672", label: "Antarctica", flag: "🇦🇶", iso: "AQ" },
  { code: "+1-268", label: "Antigua and Barbuda", flag: "🇦🇬", iso: "AG" },
  { code: "+54", label: "Argentina", flag: "🇦🇷", iso: "AR" },
  { code: "+374", label: "Armenia", flag: "🇦🇲", iso: "AM" },
  { code: "+297", label: "Aruba", flag: "🇦🇼", iso: "AW" },
  { code: "+61", label: "Australia", flag: "🇦🇺", iso: "AU" },
  { code: "+43", label: "Austria", flag: "🇦🇹", iso: "AT" },
  { code: "+994", label: "Azerbaijan", flag: "🇦🇿", iso: "AZ" },
  { code: "+1-242", label: "Bahamas", flag: "🇧🇸", iso: "BS" },
  { code: "+973", label: "Bahrain", flag: "🇧🇭", iso: "BH" },
  { code: "+880", label: "Bangladesh", flag: "🇧🇩", iso: "BD" },
  { code: "+1-246", label: "Barbados", flag: "🇧🇧", iso: "BB" },
  { code: "+375", label: "Belarus", flag: "🇧🇾", iso: "BY" },
  { code: "+32", label: "Belgium", flag: "🇧🇪", iso: "BE" },
  { code: "+501", label: "Belize", flag: "🇧🇿", iso: "BZ" },
  { code: "+229", label: "Benin", flag: "🇧🇯", iso: "BJ" },
  { code: "+1-441", label: "Bermuda", flag: "🇧🇲", iso: "BM" },
  { code: "+975", label: "Bhutan", flag: "🇧🇹", iso: "BT" },
  { code: "+591", label: "Bolivia", flag: "🇧🇴", iso: "BO" },
  { code: "+387", label: "Bosnia and Herzegovina", flag: "🇧🇦", iso: "BA" },
  { code: "+267", label: "Botswana", flag: "🇧🇼", iso: "BW" },
  { code: "+55", label: "Brazil", flag: "🇧🇷", iso: "BR" },
  { code: "+246", label: "British Indian Ocean Territory", flag: "🇮🇴", iso: "IO" },
  { code: "+1-284", label: "British Virgin Islands", flag: "🇻🇬", iso: "VG" },
  { code: "+673", label: "Brunei", flag: "🇧🇳", iso: "BN" },
  { code: "+359", label: "Bulgaria", flag: "🇧🇬", iso: "BG" },
  { code: "+226", label: "Burkina Faso", flag: "🇧🇫", iso: "BF" },
  { code: "+257", label: "Burundi", flag: "🇧🇮", iso: "BI" },
  { code: "+855", label: "Cambodia", flag: "🇰🇭", iso: "KH" },
  { code: "+237", label: "Cameroon", flag: "🇨🇲", iso: "CM" },
  { code: "+1", label: "Canada", flag: "🇨🇦", iso: "CA" },
  { code: "+238", label: "Cape Verde", flag: "🇨🇻", iso: "CV" },
  { code: "+1-345", label: "Cayman Islands", flag: "🇰🇾", iso: "KY" },
  { code: "+236", label: "Central African Republic", flag: "🇨🇫", iso: "CF" },
  { code: "+235", label: "Chad", flag: "🇹🇩", iso: "TD" },
  { code: "+56", label: "Chile", flag: "🇨🇱", iso: "CL" },
  { code: "+86", label: "China", flag: "🇨🇳", iso: "CN" },
  { code: "+61", label: "Christmas Island", flag: "🇨🇽", iso: "CX" },
  { code: "+61", label: "Cocos Islands", flag: "🇨🇨", iso: "CC" },
  { code: "+57", label: "Colombia", flag: "🇨🇴", iso: "CO" },
  { code: "+269", label: "Comoros", flag: "🇰🇲", iso: "KM" },
  { code: "+682", label: "Cook Islands", flag: "🇨🇰", iso: "CK" },
  { code: "+506", label: "Costa Rica", flag: "🇨🇷", iso: "CR" },
  { code: "+385", label: "Croatia", flag: "🇭🇷", iso: "HR" },
  { code: "+53", label: "Cuba", flag: "🇨🇺", iso: "CU" },
  { code: "+599", label: "Curacao", flag: "🇨🇼", iso: "CW" },
  { code: "+357", label: "Cyprus", flag: "🇨🇾", iso: "CY" },
  { code: "+420", label: "Czech Republic", flag: "🇨🇿", iso: "CZ" },
  { code: "+243", label: "Democratic Republic of the Congo", flag: "🇨🇩", iso: "CD" },
  { code: "+45", label: "Denmark", flag: "🇩🇰", iso: "DK" },
  { code: "+253", label: "Djibouti", flag: "🇩🇯", iso: "DJ" },
  { code: "+1-767", label: "Dominica", flag: "🇩🇲", iso: "DM" },
  { code: "+1-809", label: "Dominican Republic", flag: "🇩🇴", iso: "DO" },
  { code: "+670", label: "East Timor", flag: "🇹🇱", iso: "TL" },
  { code: "+593", label: "Ecuador", flag: "🇪🇨", iso: "EC" },
  { code: "+20", label: "Egypt", flag: "🇪🇬", iso: "EG" },
  { code: "+503", label: "El Salvador", flag: "🇸🇻", iso: "SV" },
  { code: "+240", label: "Equatorial Guinea", flag: "🇬🇶", iso: "GQ" },
  { code: "+291", label: "Eritrea", flag: "🇪🇷", iso: "ER" },
  { code: "+372", label: "Estonia", flag: "🇪🇪", iso: "EE" },
  { code: "+251", label: "Ethiopia", flag: "🇪🇹", iso: "ET" },
  { code: "+500", label: "Falkland Islands", flag: "🇫🇰", iso: "FK" },
  { code: "+298", label: "Faroe Islands", flag: "🇫🇴", iso: "FO" },
  { code: "+679", label: "Fiji", flag: "🇫🇯", iso: "FJ" },
  { code: "+358", label: "Finland", flag: "🇫🇮", iso: "FI" },
  { code: "+33", label: "France", flag: "🇫🇷", iso: "FR" },
  { code: "+689", label: "French Polynesia", flag: "🇵🇫", iso: "PF" },
  { code: "+241", label: "Gabon", flag: "🇬🇦", iso: "GA" },
  { code: "+220", label: "Gambia", flag: "🇬🇲", iso: "GM" },
  { code: "+995", label: "Georgia", flag: "🇬🇪", iso: "GE" },
  { code: "+49", label: "Germany", flag: "🇩🇪", iso: "DE" },
  { code: "+233", label: "Ghana", flag: "🇬🇭", iso: "GH" },
  { code: "+350", label: "Gibraltar", flag: "🇬🇮", iso: "GI" },
  { code: "+30", label: "Greece", flag: "🇬🇷", iso: "GR" },
  { code: "+299", label: "Greenland", flag: "🇬🇱", iso: "GL" },
  { code: "+1-473", label: "Grenada", flag: "🇬🇩", iso: "GD" },
  { code: "+1-671", label: "Guam", flag: "🇬🇺", iso: "GU" },
  { code: "+502", label: "Guatemala", flag: "🇬🇹", iso: "GT" },
  { code: "+224", label: "Guinea", flag: "🇬🇳", iso: "GN" },
  { code: "+245", label: "Guinea-Bissau", flag: "🇬🇼", iso: "GW" },
  { code: "+592", label: "Guyana", flag: "🇬🇾", iso: "GY" },
  { code: "+509", label: "Haiti", flag: "🇭🇹", iso: "HT" },
  { code: "+504", label: "Honduras", flag: "🇭🇳", iso: "HN" },
  { code: "+852", label: "Hong Kong", flag: "🇭🇰", iso: "HK" },
  { code: "+36", label: "Hungary", flag: "🇭🇺", iso: "HU" },
  { code: "+354", label: "Iceland", flag: "🇮🇸", iso: "IS" },
  { code: "+91", label: "India", flag: "🇮🇳", iso: "IN" },
  { code: "+62", label: "Indonesia", flag: "🇮🇩", iso: "ID" },
  { code: "+98", label: "Iran", flag: "🇮🇷", iso: "IR" },
  { code: "+964", label: "Iraq", flag: "🇮🇶", iso: "IQ" },
  { code: "+353", label: "Ireland", flag: "🇮🇪", iso: "IE" },
  { code: "+972", label: "Israel", flag: "🇮🇱", iso: "IL" },
  { code: "+39", label: "Italy", flag: "🇮🇹", iso: "IT" },
  { code: "+225", label: "Ivory Coast", flag: "🇨🇮", iso: "CI" },
  { code: "+1-876", label: "Jamaica", flag: "🇯🇲", iso: "JM" },
  { code: "+81", label: "Japan", flag: "🇯🇵", iso: "JP" },
  { code: "+962", label: "Jordan", flag: "🇯🇴", iso: "JO" },
  { code: "+7", label: "Kazakhstan", flag: "🇰🇿", iso: "KZ" },
  { code: "+254", label: "Kenya", flag: "🇰🇪", iso: "KE" },
  { code: "+686", label: "Kiribati", flag: "🇰🇮", iso: "KI" },
  { code: "+383", label: "Kosovo", flag: "🇽🇰", iso: "XK" },
  { code: "+965", label: "Kuwait", flag: "🇰🇼", iso: "KW" },
  { code: "+996", label: "Kyrgyzstan", flag: "🇰🇬", iso: "KG" },
  { code: "+856", label: "Laos", flag: "🇱🇦", iso: "LA" },
  { code: "+371", label: "Latvia", flag: "🇱🇻", iso: "LV" },
  { code: "+961", label: "Lebanon", flag: "🇱🇧", iso: "LB" },
  { code: "+266", label: "Lesotho", flag: "🇱🇸", iso: "LS" },
  { code: "+231", label: "Liberia", flag: "🇱🇷", iso: "LR" },
  { code: "+218", label: "Libya", flag: "🇱🇾", iso: "LY" },
  { code: "+423", label: "Liechtenstein", flag: "🇱🇮", iso: "LI" },
  { code: "+370", label: "Lithuania", flag: "🇱🇹", iso: "LT" },
  { code: "+352", label: "Luxembourg", flag: "🇱🇺", iso: "LU" },
  { code: "+853", label: "Macau", flag: "🇲🇴", iso: "MO" },
  { code: "+389", label: "Macedonia", flag: "🇲🇰", iso: "MK" },
  { code: "+261", label: "Madagascar", flag: "🇲🇬", iso: "MG" },
  { code: "+265", label: "Malawi", flag: "🇲🇼", iso: "MW" },
  { code: "+60", label: "Malaysia", flag: "🇲🇾", iso: "MY" },
  { code: "+960", label: "Maldives", flag: "🇲🇻", iso: "MV" },
  { code: "+223", label: "Mali", flag: "🇲🇱", iso: "ML" },
  { code: "+356", label: "Malta", flag: "🇲🇹", iso: "MT" },
  { code: "+692", label: "Marshall Islands", flag: "🇲🇭", iso: "MH" },
  { code: "+222", label: "Mauritania", flag: "🇲🇷", iso: "MR" },
  { code: "+230", label: "Mauritius", flag: "🇲🇺", iso: "MU" },
  { code: "+262", label: "Mayotte", flag: "🇾🇹", iso: "YT" },
  { code: "+52", label: "Mexico", flag: "🇲🇽", iso: "MX" },
  { code: "+691", label: "Micronesia", flag: "🇫🇲", iso: "FM" },
  { code: "+373", label: "Moldova", flag: "🇲🇩", iso: "MD" },
  { code: "+377", label: "Monaco", flag: "🇲🇨", iso: "MC" },
  { code: "+976", label: "Mongolia", flag: "🇲🇳", iso: "MN" },
  { code: "+382", label: "Montenegro", flag: "🇲🇪", iso: "ME" },
  { code: "+1-664", label: "Montserrat", flag: "🇲🇸", iso: "MS" },
  { code: "+212", label: "Morocco", flag: "🇲🇦", iso: "MA" },
  { code: "+258", label: "Mozambique", flag: "🇲🇿", iso: "MZ" },
  { code: "+95", label: "Myanmar", flag: "🇲🇲", iso: "MM" },
  { code: "+264", label: "Namibia", flag: "🇳🇦", iso: "NA" },
  { code: "+674", label: "Nauru", flag: "🇳🇷", iso: "NR" },
  { code: "+977", label: "Nepal", flag: "🇳🇵", iso: "NP" },
  { code: "+31", label: "Netherlands", flag: "🇳🇱", iso: "NL" },
  { code: "+687", label: "New Caledonia", flag: "🇳🇨", iso: "NC" },
  { code: "+64", label: "New Zealand", flag: "🇳🇿", iso: "NZ" },
  { code: "+505", label: "Nicaragua", flag: "🇳🇮", iso: "NI" },
  { code: "+227", label: "Niger", flag: "🇳🇪", iso: "NE" },
  { code: "+234", label: "Nigeria", flag: "🇳🇬", iso: "NG" },
  { code: "+683", label: "Niue", flag: "🇳🇺", iso: "NU" },
  { code: "+672", label: "Norfolk Island", flag: "🇳🇫", iso: "NF" },
  { code: "+850", label: "North Korea", flag: "🇰🇵", iso: "KP" },
  { code: "+1-670", label: "Northern Mariana Islands", flag: "🇲🇵", iso: "MP" },
  { code: "+47", label: "Norway", flag: "🇳🇴", iso: "NO" },
  { code: "+968", label: "Oman", flag: "🇴🇲", iso: "OM" },
  { code: "+92", label: "Pakistan", flag: "🇵🇰", iso: "PK" },
  { code: "+680", label: "Palau", flag: "🇵🇼", iso: "PW" },
  { code: "+970", label: "Palestine", flag: "🇵🇸", iso: "PS" },
  { code: "+507", label: "Panama", flag: "🇵🇦", iso: "PA" },
  { code: "+675", label: "Papua New Guinea", flag: "🇵🇬", iso: "PG" },
  { code: "+595", label: "Paraguay", flag: "🇵🇾", iso: "PY" },
  { code: "+51", label: "Peru", flag: "🇵🇪", iso: "PE" },
  { code: "+63", label: "Philippines", flag: "🇵🇭", iso: "PH" },
  { code: "+48", label: "Poland", flag: "🇵🇱", iso: "PL" },
  { code: "+351", label: "Portugal", flag: "🇵🇹", iso: "PT" },
  { code: "+1-787", label: "Puerto Rico", flag: "🇵🇷", iso: "PR" },
  { code: "+974", label: "Qatar", flag: "🇶🇦", iso: "QA" },
  { code: "+242", label: "Republic of the Congo", flag: "🇨🇬", iso: "CG" },
  { code: "+262", label: "Reunion", flag: "🇷🇪", iso: "RE" },
  { code: "+40", label: "Romania", flag: "🇷🇴", iso: "RO" },
  { code: "+7", label: "Russia", flag: "🇷🇺", iso: "RU" },
  { code: "+250", label: "Rwanda", flag: "🇷🇼", iso: "RW" },
  { code: "+590", label: "Saint Barthelemy", flag: "🇧🇱", iso: "BL" },
  { code: "+290", label: "Saint Helena", flag: "🇸🇭", iso: "SH" },
  { code: "+1-869", label: "Saint Kitts and Nevis", flag: "🇰🇳", iso: "KN" },
  { code: "+1-758", label: "Saint Lucia", flag: "🇱🇨", iso: "LC" },
  { code: "+590", label: "Saint Martin", flag: "🇲🇫", iso: "MF" },
  { code: "+508", label: "Saint Pierre and Miquelon", flag: "🇵🇲", iso: "PM" },
  { code: "+1-784", label: "Saint Vincent and the Grenadines", flag: "🇻🇨", iso: "VC" },
  { code: "+685", label: "Samoa", flag: "🇼🇸", iso: "WS" },
  { code: "+378", label: "San Marino", flag: "🇸🇲", iso: "SM" },
  { code: "+239", label: "Sao Tome and Principe", flag: "🇸🇹", iso: "ST" },
  { code: "+966", label: "Saudi Arabia", flag: "🇸🇦", iso: "SA" },
  { code: "+221", label: "Senegal", flag: "🇸🇳", iso: "SN" },
  { code: "+381", label: "Serbia", flag: "🇷🇸", iso: "RS" },
  { code: "+248", label: "Seychelles", flag: "🇸🇨", iso: "SC" },
  { code: "+232", label: "Sierra Leone", flag: "🇸🇱", iso: "SL" },
  { code: "+65", label: "Singapore", flag: "🇸🇬", iso: "SG" },
  { code: "+7-840", label: "Sint Maarten", flag: "🇸🇽", iso: "SX" },
  { code: "+421", label: "Slovakia", flag: "🇸🇰", iso: "SK" },
  { code: "+386", label: "Slovenia", flag: "🇸🇮", iso: "SI" },
  { code: "+677", label: "Solomon Islands", flag: "🇸🇧", iso: "SB" },
  { code: "+252", label: "Somalia", flag: "🇸🇴", iso: "SO" },
  { code: "+27", label: "South Africa", flag: "🇿🇦", iso: "ZA" },
  { code: "+82", label: "South Korea", flag: "🇰🇷", iso: "KR" },
  { code: "+211", label: "South Sudan", flag: "🇸🇸", iso: "SS" },
  { code: "+34", label: "Spain", flag: "🇪🇸", iso: "ES" },
  { code: "+94", label: "Sri Lanka", flag: "🇱🇰", iso: "LK" },
  { code: "+249", label: "Sudan", flag: "🇸🇩", iso: "SD" },
  { code: "+597", label: "Suriname", flag: "🇸🇷", iso: "SR" },
  { code: "+268", label: "Swaziland", flag: "🇸🇿", iso: "SZ" },
  { code: "+46", label: "Sweden", flag: "🇸🇪", iso: "SE" },
  { code: "+41", label: "Switzerland", flag: "🇨🇭", iso: "CH" },
  { code: "+963", label: "Syria", flag: "🇸🇾", iso: "SY" },
  { code: "+886", label: "Taiwan", flag: "🇹🇼", iso: "TW" },
  { code: "+992", label: "Tajikistan", flag: "🇹🇯", iso: "TJ" },
  { code: "+255", label: "Tanzania", flag: "🇹🇿", iso: "TZ" },
  { code: "+66", label: "Thailand", flag: "🇹🇭", iso: "TH" },
  { code: "+228", label: "Togo", flag: "🇹🇬", iso: "TG" },
  { code: "+690", label: "Tokelau", flag: "🇹🇰", iso: "TK" },
  { code: "+676", label: "Tonga", flag: "🇹🇴", iso: "TO" },
  { code: "+1-868", label: "Trinidad and Tobago", flag: "🇹🇹", iso: "TT" },
  { code: "+216", label: "Tunisia", flag: "🇹🇳", iso: "TN" },
  { code: "+90", label: "Turkey", flag: "🇹🇷", iso: "TR" },
  { code: "+993", label: "Turkmenistan", flag: "🇹🇲", iso: "TM" },
  { code: "+1-649", label: "Turks and Caicos Islands", flag: "🇹🇨", iso: "TC" },
  { code: "+688", label: "Tuvalu", flag: "🇹🇻", iso: "TV" },
  { code: "+1-340", label: "U.S. Virgin Islands", flag: "🇻🇮", iso: "VI" },
  { code: "+256", label: "Uganda", flag: "🇺🇬", iso: "UG" },
  { code: "+380", label: "Ukraine", flag: "🇺🇦", iso: "UA" },
  { code: "+971", label: "United Arab Emirates", flag: "🇦🇪", iso: "AE" },
  { code: "+44", label: "United Kingdom", flag: "🇬🇧", iso: "GB" },
  { code: "+1", label: "United States", flag: "🇺🇸", iso: "US" },
  { code: "+598", label: "Uruguay", flag: "🇺🇾", iso: "UY" },
  { code: "+998", label: "Uzbekistan", flag: "🇺🇿", iso: "UZ" },
  { code: "+678", label: "Vanuatu", flag: "🇻🇺", iso: "VU" },
  { code: "+39", label: "Vatican", flag: "🇻🇦", iso: "VA" },
  { code: "+58", label: "Venezuela", flag: "🇻🇪", iso: "VE" },
  { code: "+84", label: "Vietnam", flag: "🇻🇳", iso: "VN" },
  { code: "+681", label: "Wallis and Futuna", flag: "🇼🇫", iso: "WF" },
  { code: "+212", label: "Western Sahara", flag: "🇪🇭", iso: "EH" },
  { code: "+967", label: "Yemen", flag: "🇾🇪", iso: "YE" },
  { code: "+260", label: "Zambia", flag: "🇿🇲", iso: "ZM" },
  { code: "+263", label: "Zimbabwe", flag: "🇿🇼", iso: "ZW" },
];
